import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";

import routes from "constants/routes";

const NAV_ITEMS = [
  {
    id: "tenants",
    label: "Tenants",
    icon: ApartmentIcon,
    route: routes.tenants.tenants,
    match: (pathname) =>
      pathname.startsWith("/tenants") ||
      pathname.startsWith("/tenantDetails") ||
      pathname.startsWith("/createTenant") ||
      pathname.startsWith("/uploadTenants"),
  },
  {
    id: "branches",
    label: "Branches",
    icon: AccountTreeIcon,
    route: routes.branch.branch,
    match: (pathname) =>
      pathname.startsWith("/branch") ||
      pathname.startsWith("/branchDetails") ||
      pathname.startsWith("/createBranch") ||
      pathname.startsWith("/uploadBranches"),
  },
  {
    id: "schools",
    label: "Schools",
    icon: SchoolOutlinedIcon,
    route: routes.schools.schools,
    match: (pathname) =>
      pathname.startsWith(routes.schools.schools) ||
      pathname.startsWith(routes.createSchool.createSchool) ||
      pathname.startsWith(routes.schoolDetails.schoolDetails),
  },
  {
    id: "onboarding",
    label: "OnBoarding",
    icon: PersonAddIcon,
    route: routes.onBoarding.onBoarding,
    match: (pathname) => pathname.startsWith(routes.onBoarding.onBoarding),
  },
];

const AppSidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <aside className="sidebar" aria-label="Sidebar">
      <nav className="app-sidebar-nav" aria-label="Main navigation">
        {NAV_ITEMS.map(({ id, label, icon: Icon, route, match }) => {
          const isActive = match(pathname);

          return (
            <button
              key={id}
              type="button"
              className={`app-nav-item${isActive ? " app-nav-item--active" : ""}`}
              onClick={() => navigate(route)}
            >
              <span className="app-nav-icon">
                <Icon />
              </span>
              <span className="app-nav-label">{label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default AppSidebar;
